import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { getCallTypes, getCallStatuses, addCorrespondence } from "../../../services/insurance/correspondence"
export default function AddCorrespondenceDialog(props) {

    const [callTypeAPI, setCallTypeAPI] = React.useState([]);
    const [callStatusAPI, setCallStatusAPI] = React.useState([]);
    const [details] = React.useState(props.details);
    const [dateTimeFirst, setDateTimeFirst] = React.useState(null);
    const [receiverType, setReceiverType] = React.useState('');
    const [callStatus, setCallStatus] = React.useState('');
    const [statusType, setStatusType] = React.useState('');
    const [uIC, setUIC] = React.useState('');
    const [notes, setNotes] = React.useState('');


    useEffect(() => {
        let isMounted = true;
        if(isMounted){
            getCallTypes().then(res => {
                setCallTypeAPI(res.results)
            })
            getCallStatuses().then(res => {
                setCallStatusAPI(res.results)
            })
        }
        return () => { isMounted = false };
    }, [details])

    const handleFieldChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        switchCase(name, value);
    }

    console.log("details", details)
    console.log("requestJSON", details.requestJSON)

    const submitDetails = (event) => {
        event.preventDefault();
        let obj = {
            additionalInfo: { uicnumber: uIC, DND: false, DNDCustomer: false, From: "Esales",  callbackdate : dateTimeFirst },
            DND: false,
            DNDCustomer: false,
            From: "Esales",
            uicnumber: uIC,
            attachFiles: {},
            callStatus: callStatus,
            callType: receiverType,
            comment: notes,
            correspondenceType: 153,
            createdBy: JSON.parse(localStorage.getItem('user_details')).userId,
            createdOn: new Date(),
            requestFlowId: details.id,
            requestId: details.id,
            workStatus: statusType,
        }
        console.log(" obj . SUBMIT.", obj);
        addCorrespondence(obj).then(res => {
            if (res.isSuccess) {
                console.log("res ..", res)
                props.closeDialog();
            }
        })

    }

    const closePopUp = () => {
        props.closeDialog();
    }

    const switchCase = (name, value) => {
        switch (name) {
            case 'ReceiverType':
                setReceiverType(value);
                break;
            case 'callStatus':
                setCallStatus(value);
                break;
            case 'statusType':
                setStatusType(value);
                break;
            case 'UIC':
                setUIC(value);
                break;
            case 'callbackdate':
                setDateTimeFirst(value)
                break;
            case 'notes':
                setNotes(value);
                break;
            default:
                break;
        }
    }


    return (
        <div className="mt-5">
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={(event) => submitDetails(event)}
            >
                <div className="pb-5">
                    <FormControl className="w-full">
                        <InputLabel id="ReceiverType">Select a Receiver</InputLabel>
                        <Select
                            labelId="ReceiverType"
                            id="ReceiverType"
                            name="ReceiverType"
                            label="Select a Receiver"
                            value={receiverType}
                            onChange={(event) => handleFieldChange(event)}
                        >
                            {
                                callTypeAPI ? callTypeAPI.map(elem => (
                                    <MenuItem value={elem.key} key={elem.key}>{elem.value}</MenuItem>
                                )) : <></>
                            }
                        </Select>
                    </FormControl>
                </div>

                <div className="pb-5">
                    <FormControl className="w-full pb-10">
                        <InputLabel id="callStatus">Select appropriate call status</InputLabel>
                        <Select
                            labelId="callStatus"
                            id="callStatus"
                            name="callStatus"
                            value={callStatus}
                            onChange={(event) => handleFieldChange(event)}
                            label="Select appropriate call status"
                        >
                            {
                                callStatusAPI ? callStatusAPI.map(elem => (
                                    <MenuItem value={elem.key} key={elem.key} >{elem.value}</MenuItem>
                                )) : <></>
                            }
                        </Select>
                    </FormControl>
                </div>

                <div className="pb-5">
                    <FormControl className="w-full pb-10">
                        <InputLabel id="statusType">Select type of status</InputLabel>
                        <Select
                            labelId="statusType"
                            id="statusType"
                            name="statusType"
                            value={statusType}
                            onChange={(event) => handleFieldChange(event)}
                            label="Select type of status"
                        >
                            <MenuItem value={'workable'}>Workable</MenuItem>
                            <MenuItem value={'nonWorkable'}>Non Workable</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                <div className="pb-5">
                    <FormControl className="w-full">
                        <TextField
                            required
                            id="outlined-required"
                            label="UIC number"
                            name="UIC"
                            value={uIC}
                            onChange={(event) => handleFieldChange(event)}
                        />
                    </FormControl>
                </div>

                {
                    (callStatus === '73' || callStatus === '74' || callStatus === '86' || callStatus === '96' || callStatus === '144' || callStatus === '187') ?
                        <div className="pb-5">
                            <FormControl className="w-full">
                                <TextField
                                    id="callbackdate"
                                    name="callbackdate"
                                    label="First Preference"
                                    type="datetime-local"
                                    InputProps={{ inputProps: { min: new Date() } }}
                                    defaultValue={dateTimeFirst !=null ? dateTimeFirst : ''}
                                    onChange={(event) => handleFieldChange(event)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </FormControl>
                        </div>
                        : <></>

                }

                <div className="pb-5">
                    <FormControl className="w-full">
                        <TextField
                            id="outlined-multiline-static"
                            label="Add correspondence notes"
                            multiline
                            name="notes"
                            onChange={(event) => handleFieldChange(event)}
                            rows={4}
                            value={notes}
                        />
                    </FormControl>
                </div>
                <div className='pb-5 flex justify-center text-center'>
                    <div className="m-auto bg-blue-500 rounded-md w-40 text-gray-100 p-1 cursor-pointer font-semibold" type="submit" variant="contained" size="large" onClick={submitDetails}>
                        <span>
                            Submit
                        </span>
                    </div>
                    <div className="m-auto bg-red-500 rounded-md w-40 text-red-100 p-1 cursor-pointer font-semibold" type="submit" variant="contained" size="large" onClick={closePopUp}>
                        <span>
                            Cancel
                        </span>
                    </div>
                </div>
            </Box>
        </div>
    );
}